import type { GetRetailerProfileOptionResponseItem } from '@packages/clients';

import type { RetailerProfileOption } from '../types';

// Exception: 1:1 field copy. This mapper exists as an intentional DTO-to-entity boundary firewall so that
// domain code never depends directly on the GetRetailerProfileOptionResponseItem DTO type, even though
// the shapes currently match.
/**
 * Map a `GetRetailerProfileOptionResponseItem` DTO to a `RetailerProfileOption`. The shapes are currently
 * identical; this mapper establishes the DTO-to-domain boundary.
 *
 * @param dto - the GetRetailerProfileOptionResponseItem DTO from the API
 * @returns the mapped entity
 * @example
 * ```ts
 * const entity = toRetailerProfileOption(apiResponse.data.results[0]);
 * ```
 */
export function toRetailerProfileOption(dto: GetRetailerProfileOptionResponseItem): RetailerProfileOption {
    return {
        retailerId: dto.retailerId,
        retailerName: dto.retailerName,
        retailerNumber: dto.retailerNumber,
        userName: dto.userName,
    };
}
